// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__2roMj","frame":"Dialog_frame___hEDu","closeButton":"Dialog_closeButton___Rct_","okButton":"Dialog_okButton__3v02j","body":"Dialog_body__1X4Q4"};